import { AppApiURL, AppDomainURL } from '@app/app.settings';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import {
  AddMusicianProfileDto,
  AddMusicianProfileResult,
  IMusicianUserInfo,
  IMusicianUpdateMyInfo,
  MusicianSignUpRequest
} from '@app/modules/musician-modules/musician.model';
import { RoutingConfig } from '@app/routing/routing.config';
import { HttpRequestToken } from '@app/core/classes';
import { AuthSignUpResponse } from '@app/modules/auth-modules/auth.model';


@Injectable()

export class MusicianService {
  constructor(
    private http: HttpClient
  ) {}

  /**
   * POST /musician/signUp — register with musician profile (same token response shape as /account/signUp).
   */
  public musicianSignUp(request: MusicianSignUpRequest): Observable<AuthSignUpResponse> {
    const returnPath = `?confirmEmailPath=${AppDomainURL}/${RoutingConfig.Account}/${RoutingConfig.AccountConfirmEmail}`;

    return this.http
      .post<AuthSignUpResponse>(AppApiURL + `/musician/signUp${returnPath}`, request, {
        withCredentials: true,
        observe: 'response',
        reportProgress: false,
        params: new HttpRequestToken(true)
      })
      .pipe(
        timeout(10000),
        map((response: HttpResponse<AuthSignUpResponse>) => response?.body),
        catchError((error: HttpErrorResponse) => {
          if (error.hasOwnProperty('error')) {
            return throwError(error.error);
          }
          return throwError(error);
        })
      );
  }

  /**
   * POST /musician/profile — create musician profile (after account exists, etc.).
   */
  public addMusicianProfile(request: AddMusicianProfileDto): Observable<AddMusicianProfileResult> {
    return this.http.post<AddMusicianProfileResult>(AppApiURL + '/musician/profile', request,
      {
        withCredentials: true,
        observe: 'response',
        reportProgress: false
      }
    ).pipe(
      map((response: HttpResponse<AddMusicianProfileResult>) => response?.body),
      catchError((error: HttpErrorResponse) => {
        if (error.hasOwnProperty('error')) {
          return throwError(error.error);
        }
        return throwError(error);
      })
    );
  }

  /**
   * DELETE /musician/profile — delete musician profile (API removes the musician role).
   */
  public deleteMusicianProfile(): Observable<void> {
    return this.http.delete(AppApiURL + '/musician/profile', {
      withCredentials: true,
      observe: 'response',
      reportProgress: false
    }).pipe(
      map(() => undefined),
      catchError((error: HttpErrorResponse) => {
        if (error.hasOwnProperty('error')) {
          return throwError(error.error);
        }
        return throwError(error);
      })
    );
  }

  /**
   * Api: v01.
   * Method: Musician musicianUserInfo
   */
  public musicianUserInfo(): Observable<IMusicianUserInfo> {
    return this.http.post<IMusicianUserInfo>(AppApiURL + '/musician/musicianUserInfo', null,
      {
        withCredentials: true,
        observe: 'response',
        reportProgress: false
      }
    ).pipe(
      map((response: HttpResponse<any>) => response?.body)
    )
  }


  /**
   * Api: v01.
   * Method: Musician updateMyInfo
   */
  public updateMyInfo(request: IMusicianUpdateMyInfo): Observable<IMusicianUserInfo> {
    return this.http.post<IMusicianUserInfo>(AppApiURL + '/musician/updateMyInfo', request,
      {
        withCredentials: true,
        observe: 'response',
        reportProgress: false
      }
    ).pipe(
      map((response: HttpResponse<any>) => response?.body)
    )
  }
}
